import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const useStyles = makeStyles((theme) =>
  createStyles({
    chips: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      background: theme.palette.type === 'dark' ? '#28313f' : COLORS.LIGHT_BACKGROUND,
      borderRadius: 5,
      // padding: 10,

      '&:not(:first-child)': {
        marginTop: 10,
      },
      '& .MuiSelect-select:focus': {
        background: 'transparent !important',
      },
    },

    wrapper: {
      padding: '10px 13px 10px 10px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& .MuiSvgIcon-root': {
        // cursor: 'pointer',
        fontSize: 20,
        '& path': {
          fill: '#d83032',
        },
        '.MuiOutlinedInput-input': {
          padding: 0,
        },
      },
    },
    acessCodeCont: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
    },
    name: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: 200,
      overflow: 'hidden',
    },
  }),
);
